export const OVERLAY_ERROR = 'OVERLAY_ERROR';
export const OVERLAY_REQUEST = 'OVERLAY_REQUEST';
export const OVERLAY_RESET = 'OVERLAY_RESET';
export const OVERLAY_SET_AD = 'OVERLAY_SET_AD';
export const OVERLAY_SET_ALERT = 'OVERLAY_SET_ALERT';
export const OVERLAY_REMOVE_ALERT = 'OVERLAY_REMOVE_ALERT';
export const OVERLAY_SUCCESS = 'OVERLAY_SUCCESS';
export const OVERLAY_SET_MATCH_DATA = 'OVERLAY_SET_MATCH_DATA';
